<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">{{ title ? 'Komentar za: ' + title : 'Komentar'}}</h3>
    </div>
    <div class="card-body">
      <textarea class="form-control" 
                rows="2" 
                name="comment"
                placeholder="Unesi komentar"
                [disabled]="!isEnabled"
                [(ngModel)]="comment"></textarea>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" *ngIf="isEnabled">Sačuvaj</button>
    </div>
  </div>
</div>
